import {useStore} from '@/store/root-store';
import {Progress, Spin, Tooltip} from 'antd';
import {observer} from 'mobx-react-lite';
import {useTranslation} from 'next-i18next';
import styled from 'styled-components';
import {getProgressColor} from '@/utils/colors';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faCircleInfo} from '@fortawesome/pro-regular-svg-icons';
import {PageSpeedIndex} from '../PageSpeedIndex';
import {LoadingOutlined} from '@ant-design/icons';


export const TechnicalScore = observer(() => {
  const {
    contentOptimizer: {
      currentPage,
    }} = useStore('');

  const {t} = useTranslation('common');

  const antIcon = <LoadingOutlined style={{fontSize: 14, color: '#E1E1E1'}} spin />;


  const technicalsMsgColorMap = [
    {
      color: '#1FAC47',
      msg: 'Technical score is Very Good',
    },
    {
      color: '#BFE15E',
      msg: 'Technical score is Good',
    },
    {
      color: '#FF8536',
      msg: 'Technical score Needs Improvement',
    },
    {
      color: '#F44343',
      msg: 'Technical score is Bad',
    },
    {
      color: '#B62222',
      msg: 'Technical score is Very Bad',
    },
  ];

  const getTechnicalsMsg = value => {
    if (value < 60) {
      return technicalsMsgColorMap[4].msg;
    } else if (value > 59 && value < 70) {
      return technicalsMsgColorMap[3].msg;
    } else if (value > 69 && value < 80) {
      return technicalsMsgColorMap[2].msg;
    } else if (value > 79 && value < 90) {
      return technicalsMsgColorMap[1].msg;
    } else {
      return technicalsMsgColorMap[0].msg;
    }
  };


  return <Container>
    <ProgressStyled
      percent={!currentPage.isScoreLoading ? currentPage?.analysis?.technicalScore ?? 0 : 50}
      strokeLinecap='round'
      gapDegree={140}
      gapPosition={'bottom'}
      trailColor='#4E5156'
      strokeColor={!currentPage.isScoreLoading ? getProgressColor(currentPage?.analysis?.technicalScore, 25, 50, 75) : '#7E8184'}
      showInfo={true}
      type='dashboard'
      width={50}
      strokeWidth={10}
      size='small'
      format={() => <span style={{color: '#fff', fontSize: '18px', fontWeight: 'bold'}}>{!currentPage.isScoreLoading ? (currentPage?.analysis?.technicalScore ?? '-') : <Spin indicator={antIcon} />}</span>} />
    <TitleAndWordCount>
      <TitleContainer>
        <Title>{t('technical-score')}</Title>
        <Tooltip title={getTechnicalsMsg(currentPage?.analysis?.technicalScore)}>
          <FontAwesomeIcon icon={faCircleInfo} style={{marginLeft: 5}}/>
        </Tooltip>
      </TitleContainer>

      <PageSpeedIndex />
    </TitleAndWordCount>

  </Container>;
});

const Container = styled.div`
  width: 100%;
  display: flex;
  height: 30px;
`;
const TitleContainer = styled.div`
  display: flex;
  align-items: center;
`;
const Title = styled.div`
  font-weight: 500;
  line-height: 17px;
  color: #fff;
`;
const TitleAndWordCount = styled.div`
  margin-left: 10px;
`;
const ProgressStyled = styled(Progress)`
  .ant-progress-text {
    top: 40%;
  }
`;
